export const cellRenderForSalesOrdersGrid = (params) => {
  if (params.data.free_movement_data_exist && params.data.zero_price_item_exists) {
    return `<span>U &#8364;</span>`
  } else if (params.data.free_movement_data_exist) {
    return `<span>U</span>`
  } else if (params.data.zero_price_item_exists) {
    return `<span>&#8364;</span>`
  }
};



// WEBPACK FOOTER //
// ./src/helpers/salesOrdersHelpers.js